export const productData = [
  {
    id: 1,
    name: "Headphone 1",
    category: "headphone",
    price: 93,
    featured: true,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/headphone1.jpg",
    colors: ["#14a690", "#f20790"],
    stock: 14,
    rating: 4.9,
  },
  {
    id: 2,
    name: "Headphone 2",
    category: "headphone",

    price: 383,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/headphone2.jpg",
    colors: ["#00f265", "#db4b5e", "#f20790"],
    stock: 9,
    rating: 4.2,
  },
  {
    id: 3,
    name: "Headphone 3",
    category: "headphone",

    price: 9123,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/headphone3.jpg",
    colors: ["#00f265", "#db4b5e"],
    stock: 4,
    rating: 4.9,
  },
  {
    id: 4,
    name: "Headphone 4",
    category: "headphone",
    price: 7223,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/headphone4.jpg",
    colors: ["#000000", "#00ffe5"],
    stock: 7,
    rating: 3.4,
  },
  {
    id: 5,
    name: "Bag 1",
    category: "bag",
    price: 423,
    featured: true,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/bag1.jpg",
    colors: ["#000000", "#db4b5e", "#f20790", "#00ffe5"],
    stock: 8,
    rating: 3.9,
  },
  {
    id: 6,
    name: "Bag 2",
    category: "bag",
    price: 3223,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/bag2.jpg",
    colors: ["#000000", "#00ffe5"],
    stock: 5,
    rating: 4.9,
  },
  {
    id: 7,
    name: "Bag 3",
    category: "bag",
    price: 223,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/bag3.jpg",
    colors: ["#000000", "#00ffe5"],
    stock: 7,
    rating: 4.7,
  },
  {
    id: 8,
    name: "Bag 4",
    category: "bag",
    price: 2293,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/bag4.jpg",
    colors: ["#000000", "#db4b5e", "#f20790", "#00ffe5"],
    stock: 9,
    rating: 4.2,
  },
  {
    id: 9,
    name: "Watch 1",
    category: "watch",
    price: 23,
    featured: true,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/watch1.jpg",
    colors: ["#000000", "#00ffe5"],
    stock: 4,
    rating: 4,
  },
  {
    id: 10,
    name: "Watch 2",
    category: "watch",
    price: 993,

    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/watch2.jpg",
    colors: ["#000000", "#00ffe5", "#db4b5e"],
    stock: 9,
    rating: 4,
  },
  {
    id: 11,
    name: "sunglass 1",
    category: "sunglass",
    price: 883,
    featured: true,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/sunglass1.jpg",
    colors: ["#000000", "#db4b5e", "#f20790", "#00ffe5"],
    stock: 8,
    rating: 4.4,
  },
  {
    id: 12,
    name: "sunglass 2",
    category: "sunglass",
    price: 113,
    dis: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto distinctio, accusamus alias cumque quod, officia voluptatem consectetur voluptatibus totam tenetur beatae eaque voluptates ab voluptate quibusdam non quia laboriosam quam!",
    img: "/images/sunglass2.jpg",
    colors: ["#00ffe5"],
    stock: 7,
    rating: 3.4,
  },
];
